import React from 'react';

const FollowingFeedIcon = ({ width = 24, height = 24, color = '#fff' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00039 0.899902C4.52919 0.899902 0.900391 4.5287 0.900391 8.9999C0.900391 13.4711 4.52919 17.0999 9.00039 17.0999C13.4716 17.0999 17.1004 13.4711 17.1004 8.9999C17.1004 4.5287 13.4716 0.899902 9.00039 0.899902ZM5.00709 14.0867C5.35539 13.3577 7.47759 12.6449 9.00039 12.6449C10.5232 12.6449 12.6535 13.3577 12.9937 14.0867C11.8921 14.9615 10.507 15.4799 9.00039 15.4799C7.49379 15.4799 6.10869 14.9615 5.00709 14.0867ZM14.152 12.9122C12.9937 11.5028 10.183 11.0249 9.00039 11.0249C7.81779 11.0249 5.00709 11.5028 3.84879 12.9122C3.02259 11.8268 2.52039 10.4741 2.52039 8.9999C2.52039 5.4278 5.42829 2.5199 9.00039 2.5199C12.5725 2.5199 15.4804 5.4278 15.4804 8.9999C15.4804 10.4741 14.9782 11.8268 14.152 12.9122ZM9.00039 4.1399C7.42899 4.1399 6.16539 5.4035 6.16539 6.9749C6.16539 8.5463 7.42899 9.8099 9.00039 9.8099C10.5718 9.8099 11.8354 8.5463 11.8354 6.9749C11.8354 5.4035 10.5718 4.1399 9.00039 4.1399ZM9.00039 8.1899C8.32809 8.1899 7.78539 7.6472 7.78539 6.9749C7.78539 6.3026 8.32809 5.7599 9.00039 5.7599C9.67269 5.7599 10.2154 6.3026 10.2154 6.9749C10.2154 7.6472 9.67269 8.1899 9.00039 8.1899Z"
      fill={color}
    />
  </svg>
);

export default FollowingFeedIcon;
